// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/select2/dist/css/select2.css
// module id = 938
// module chunks = 1